import Slider from "./components/Slider";
import Navigation from "./components/Navigation";
import Filter from "./components/Filter";
import Lazy from "./components/Lazy";
import Tracking from "./components/Tracking";
import HaasAccordion from "./components/HaasAccordion";


const heroslider = new Slider('heroslider');
const contentslider = new Slider('contentslider');
const teamslider = new Slider('teamslider');
const referencesslider = new Slider('referencesslider');

const trackingObj = new Tracking();

const nav = new Navigation();
const filter = new Filter();
const lazy = new Lazy();
const HaasAccordionObj = new HaasAccordion();

